import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import $ from "jquery";
import moment from "moment";
import { DatePicker } from "antd";
import swal from "sweetalert2";

import OrganisationFilters from "./OrganisationFilters";
import "sweetalert2/dist/sweetalert2.min.css";

export default class ManageSwayam extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ngos: null,
      per_page: 10,
      page: 0,
      searchText: "",
      totalOrgs: null,
      searchOption: "name",
      filters: {
        trial: null,
        fromDate: null,
        toDate: null,
        published: null,
        domain: null,
        paid_for: null,
      }
    };
    this.search = this.search.bind(this);
    this.getNGOS = this.getNGOS.bind(this);
    this.handlePageClick = this.handlePageClick.bind(this);
    this.changeSearchText = this.changeSearchText.bind(this);
  }

  componentDidMount() {
    this.getNGOS(0, 10, this.state.searchText);

    var that = this;
    $(".manage-swayam-page input.search-ngo-input").keydown(function(e) {
      var keyCode = e.keyCode ? e.keyCode : e.which;
      if (keyCode == 13) {
        that.search($(this).val());
      }
    });

    $(document).click(function(e) {
      $(
        ".search-ngo-input-container > .search-type-button.filter-container"
      ).each(function() {
        if ($(e.target).parents(".filter-container")[0] === $(this)[0]) {
          // Clicked inside container
        } else $(this).find(".filter-dropdown").addClass("hidden");
      });
    });
  }

  handleImageChange(ngo_index, website_index, e){
    var ngos = this.state.ngos;
    ngos[ngo_index].websites[website_index]["coverFile"] = e.target.files[0];
    this.setState({ ngos });
  }

  handleShowOnLEChange(ngo_index, website_index, e){
    var ngos = this.state.ngos;
    ngos[ngo_index].websites[website_index]["showOnLE"] = !ngos[ngo_index].websites[website_index]["showOnLE"];
    this.setState({ ngos });
  }

  getNGOS(page, per_page, searchText) {
    var filters = this.state.filters;
    var query = "?page=" + page + "&per_page=" + per_page;
    if (searchText && searchText !== "" && this.state.searchOption === "name")
      query += "&name=" + searchText;
    else if (
      searchText &&
      searchText !== "" &&
      this.state.searchOption === "invoice"
    )
      query += "&invoice_id=" + searchText;
    else if (
      searchText &&
      searchText !== "" &&
      this.state.searchOption === "txn_id"
    )
      query += "&txn_id=" + searchText;

    if (filters.trial !== null) {
      if (filters.trial) query += "&on_trial=yes";
      else query += "&on_trial=no";
    }
    if (filters.published !== null) {
      if (filters.published) query += "&is_published=yes";
      else query += "&is_published=no";
    }
    if (filters.domain !== null) {
      if (filters.domain) query += "&domain=yes";
      else query += "&domain=no";
    }
    if (filters.paid_for !== null) {
      query += encodeURI("&paid_for=" + filters.paid_for);
    }
    if (filters.fromDate !== null)
      query += "&from_date=" + moment(filters.fromDate).format("YYYY-MM-DD");
    if (filters.toDate !== null)
      query += "&to_date=" + moment(filters.toDate).format("YYYY-MM-DD");

    this.setState({ ngos: null, totalOrgs: null });
    fetch(process.env.REACT_APP_API_URL + "/orgs" + query, {
      method: "GET",
      headers: {
        Auth: this.props.access_token
      }
    }).then(function(response) {
      return response.json();
    }).then(function(data) {
      var ngos = data.data.orgs;
      for (var i = 0; i < ngos.length; i++) {
        for (var j = 0; j < ngos[i].websites.length; j++) {
          var showOnLE = false;
          if(ngos[i].websites[j].hasOwnProperty('showOnLE') && ngos[i].websites[j].showOnLE === true) {
            showOnLE = true;
          }
          ngos[i].websites[j].showOnLE = showOnLE;
          ngos[i].websites[j].coverFile = null;
          if (ngos[i].websites[j]["publishedTill"] === "") {
            ngos[i].websites[j]["publishedTill"] = null;
          } else {
            ngos[i].websites[j]["publishedTill"] = moment(ngos[i].websites[j]["publishedTill"], "DD/MM/YYYY");
          }
        }
      }
      this.setState({
        ngos,
        totalOrgs: data.data.totalOrgs,
        pageCount: Math.ceil(data.data.totalOrgs / per_page)
      });
    }.bind(this));
  }

  handlePageClick(data) {
    let selected = data.selected;
    this.setState({ page: selected });
    this.getNGOS(selected, 10, this.state.searchText);
  }

  changeSearchText(searchText) {
    this.setState({ searchText });
  }

  search(searchText) {
    if (searchText !== this.state.searchText) this.setState({ searchText });
    if (searchText.length > 3) {
      this.setState({ page: 0 });
      this.getNGOS(0, this.state.per_page, searchText);
    }
  }

  changeTrial(value) {
    var filters = this.state.filters;
    filters["trial"] = value;
    this.setState({ filters, page: 0 }, function() {
      this.getNGOS(0, this.state.per_page, this.state.searchText);
    });
  }

  changePublished(value) {
    var filters = this.state.filters;
    filters["published"] = value;
    this.setState({ filters, page: 0 }, function() {
      this.getNGOS(0, this.state.per_page, this.state.searchText);
    });
  }

  changeHasDomain(value) {
    var filters = this.state.filters;
    filters["domain"] = value;
    this.setState({ filters, page: 0 }, function() {
      this.getNGOS(0, this.state.per_page, this.state.searchText);
    });
  }

  changePeriod(value) {
    var filters = this.state.filters;
    filters["paid_for"] = value;
    this.setState({ filters, page: 0 }, function() {
      this.getNGOS(0, this.state.per_page, this.state.searchText);
    });
  }

  changeDate(date, dateString) {
    var filters = this.state.filters;
    filters["fromDate"] = date[0];
    filters["toDate"] = date[1];
    this.setState({ filters, page: 0 }, function() {
      this.getNGOS(0, this.state.per_page, this.state.searchText);
    });
  }

  resetFilters() {
    var filters = {
      trial: null,
      fromDate: null,
      toDate: null,
      published: null,
      domain: null,
      paid_for: null
    };
    this.setState({ filters, searchText: "", page: 0 }, function() {
      this.getNGOS(0, this.state.per_page, this.state.searchText);
    });
  }

  gotoOrgPage(orgId) {
    window.location.pathname = "/manage-swayam/org/" + orgId;
  }

  changeSearchOption(type) {
    this.setState({ searchOption: type });
    $(".search-ngo-input-container > .search-type-button.filter-container .filter-dropdown").addClass("hidden");
  }

  showDropdown(target) {
    $(target).siblings(".filter-dropdown.searchDropdown-menu").removeClass("hidden");
    $(target).parent().siblings(".filter-dropdown.searchDropdown-menu").removeClass("hidden");
  }

  changeNGO(ngo_index, value) {
    var ngos = this.state.ngos;
    ngos[ngo_index].trial = value;
    this.setState({ ngos });
  }

  changeNGOWebsite(ngo_index, website_index, value) {
    var ngos = this.state.ngos;
    ngos[ngo_index].websites[website_index]["isPublished"] = value;
    this.setState({ ngos });
  }

  changePublishedTillDate(index, website_index, date, dateString) {
    var ngos = this.state.ngos;
    ngos[index].websites[website_index]["publishedTill"] = moment(date).format("YYYY-MM-DD");
    this.setState({ ngos });
  }

  saveWebsite(ngo_index, website_index) {
    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Save!",
      cancelButtonText: "No, Cancel!",
      confirmButtonClass: "btn",
      cancelButtonClass: "btn"
    }).then(
      function(result) {
        if (result.value) {
          var ngo = this.state.ngos[ngo_index];
          var website = this.state.ngos[ngo_index].websites[website_index];
          var published_till;
          if (website["publishedTill"] !== null && website["publishedTill"] !== "") {
            published_till = moment(website["publishedTill"]).format("YYYY-MM-DD");
          } else published_till = "";

          let formdata = new FormData();
          formdata.append("coverFile", website["coverFile"]);
          formdata.append("showOnLE", website["showOnLE"]);
          formdata.append("on_trial", ngo['trial']);
          formdata.append("published_till", published_till);
          formdata.append("is_published", website["isPublished"]);

          fetch(process.env.REACT_APP_API_URL + "/orgs/" + ngo.id + "/websites/" + website.id, {
            method: "PUT",
            headers: {
              Auth: this.props.access_token
            },
            body: formdata
          }).then(response => response.json())
          .then(data => {
            if(data.status === 'success') {
              swal({
                title: "Saved!",
                html: "<h4>Successfully updated Website details!</h4>",
                type: "success"
              });
              this.resetFilters(this);
              this.getNGOS(0, 10, "");
            } else {
              swal({
                title: "",
                html: "<h4>Website details updation failed!</h4>",
                type: "error"
              });
            }
          });
        }
      }.bind(this)
    );
  }

  render() {
    return (
      <div className="page-container manage-swayam-page">
        <div className="select-ngos">
          <div className="select-ngos-heading-container">
            <h2 className="select-ngos-heading">Select Organisation</h2>
            <div className="search-ngo-input-container">
              <div className="search-type-button filter-container">
                <div
                  className="filter-span"
                  onClick={e => this.showDropdown(e.target)}
                >
                  <i
                    className="fa fa-bars fa-2x"
                    onClick={e => this.showDropdown(e.target)}
                  />
                  <i
                    className="fa fa-chevron-down"
                    onClick={e => this.showDropdown(e.target)}
                  />
                </div>
                <div className="filter-dropdown hidden searchDropdown-menu">
                  <div>
                    <a
                      id="ngo-name"
                      className="ngoType"
                      onClick={this.changeSearchOption.bind(this, "name")}
                    >
                      <i className="fa fa-sitemap" /> Name
                    </a>
                  </div>
                  <div>
                    <a
                      id="ngo-invoice"
                      className="ngoType"
                      onClick={this.changeSearchOption.bind(this, "invoice")}
                    >
                      <i className="fa fa-file-text-o" /> Invoice Id
                    </a>
                  </div>
                  <div>
                    <a
                      id="ngo-txn_id"
                      className="ngoType"
                      onClick={this.changeSearchOption.bind(this, "txn_id")}
                    >
                      <i className="fa fa-file-text-o" /> Transaction Id
                    </a>
                  </div>
                </div>
              </div>
              <input
                className="search-ngo-input"
                type="text"
                value={this.state.searchText}
                placeholder={
                  this.state.searchOption === "name"
                    ? "Search by Organisation Name..."
                    : this.state.searchOption === "invoice"
                      ? "Search by Invoice ID..."
                      : "Search by Transaction ID..."
                }
                onChange={e => this.changeSearchText(e.target.value)}
              />
              <button
                className="search-ngo-button"
                onClick={() =>
                  this.search(
                    $(".manage-swayam-page input.search-ngo-input").val()
                  )
                }
              >
                <i className="fa fa-search" />
              </button>
            </div>
          </div>
          <OrganisationFilters
            filters={this.state.filters}
            resetFilters={this.resetFilters.bind(this)}
            changeTrial={this.changeTrial.bind(this)}
            changePublished={this.changePublished.bind(this)}
            changeDate={this.changeDate.bind(this)}
            changePeriod={this.changePeriod.bind(this)}
            changeHasDomain={this.changeHasDomain.bind(this)}
          />
          {this.state.totalOrgs !== null ? (
            this.state.ngos.length === 0 ? (
              <div className="total-orgs-count">
                <span>{this.state.totalOrgs + " Organisations"}</span>
              </div>
            ) : (
              <div className="total-orgs-count">
                {this.state.page * 10 + 10 < this.state.totalOrgs ? (
                  <span>
                    {String(this.state.page * 10 + 1) +
                      "-" +
                      String(this.state.page * 10 + 10) +
                      " of " +
                      this.state.totalOrgs +
                      " Organisations"}
                  </span>
                ) : (
                  <span>
                    {String(this.state.page * 10 + 1) +
                      "-" +
                      String(this.state.totalOrgs) +
                      " of " +
                      this.state.totalOrgs +
                      " Organisations"}
                  </span>
                )}
              </div>
            )
          ) : null}
          {this.state.ngos !== null ? (
            <div className="ngos-container">
              {/* Table Header */}

              <div className="table-header">
                <div className="table-heading">NGO Name</div>
                <div className="table-heading">Trial</div>
                <div className="table-heading">
                  Total
                  <br />
                  Published
                  <br />
                  Websites
                </div>
                <div className="table-website-header">
                  <p className="table-website-heading">Websites:</p>
                  <p className="table-website-heading-ispublished">
                    Is Published:
                  </p>
                  <p className="table-website-heading-published">
                    Published Till:
                  </p>
                  <p className="table-website-heading-publishedurl">
                    Published Url:
                  </p>
                  <p className="table-website-heading-publishedurl">
                    Sub-Domain Url:
                  </p>
                  <div className="addToLE-heading">
                    <p>Show On LE</p>
                  </div>
                  <div className="table-website-heading-upload">
                    <p>Cover Image</p>
                  </div>
                  <div className="save-heading">
                    <p>Save</p>
                  </div>
                </div>
              </div>

              {/* table contents */}
              {this.state.ngos !== null
                ? this.state.ngos.map(
                    function(ngo, index) {
                      return (
                        <div className="website-content" key={index}>
                          <div className="table-website-content-header">
                            <div className="table-website-ngo">
                              <a href={'/manage-swayam/org/' + ngo.id}>{ngo.name}</a>
                            </div>
                            <div className="table-website-trail">
                              <p>
                                <input
                                  onChange={this.changeNGO.bind(this, index, true)}
                                  type="radio"
                                  name={"trial-" + index}
                                  checked={ngo.trial}
                                />
                                Yes
                                <input
                                  onChange={this.changeNGO.bind(this, index, false)}
                                  type="radio"
                                  name={"trial-" + index}
                                  checked={!ngo.trial}
                                />
                                No
                              </p>
                            </div>
                            <div className="table-publishedwebsite">
                              <p>{ngo.publishedWebsites}</p>
                            </div>
                          </div>
                          <div className="website-container">
                            {ngo.websites.map(
                              function(website, website_index) {
                                return (
                                  <div
                                    className="table-website-contents"
                                    key={website_index}
                                  >
                                    <div className="table-website-content">
                                      <p>{"Websites " + (website_index + 1)}</p>
                                    </div>
                                    <div className="table-website-heading-ispublished">
                                      <p>
                                        <input
                                          onChange={this.changeNGOWebsite.bind(
                                            this,
                                            index,
                                            website_index, true
                                          )}
                                          type="radio"
                                          name={
                                            "published-" +
                                            index +
                                            "-" +
                                            website_index
                                          }
                                          checked={website.isPublished}
                                        />
                                        Yes
                                        <input
                                          onChange={this.changeNGOWebsite.bind(
                                            this,
                                            index,
                                            website_index, false
                                          )}
                                          type="radio"
                                          name={
                                            "published-" +
                                            index +
                                            "-" +
                                            website_index
                                          }
                                          checked={!website.isPublished}
                                        />
                                        No
                                      </p>
                                    </div>
                                    <div className="table-website-heading-published">
                                      <p>
                                        <DatePicker
                                          onChange={this.changePublishedTillDate.bind(
                                            this,
                                            index,
                                            website_index
                                          )}
                                          defaultValue={website.publishedTill}
                                          className="datepicker"
                                          format="DD-MM-YYYY"
                                        />
                                      </p>
                                    </div>
                                    <div className="table-website-heading-publishedurl">
                                      <a target='_blank'
                                        className="publishedurl"
                                        href={website.publishUrl.startsWith('http') ? website.publishUrl : 'http://' + website.publishUrl}
                                      >
                                        {website.publishUrl}
                                      </a>
                                    </div>
                                    <div className="table-website-heading-publishedurl">
                                      <a target='_blank'
                                        className="publishedurl"
                                        href={website.subDomainUrl}
                                      >
                                        {website.subDomainUrl}
                                      </a>
                                    </div>
                                    <div className="table-website-heading-radio">
                                      <input type="checkbox" className="radio-size" checked={website.showOnLE}
                                        onChange={this.handleShowOnLEChange.bind(this, index, website_index)}/>
                                    </div>
                                    <div className="table-website-heading-upload">
                                      <div className="fileUpload btn btn-default">
                                        <span>Upload</span>
                                        <input type="file" className="upload"
                                          onChange={this.handleImageChange.bind(this, index, website_index)}/>
                                      </div>
                                      {website.coverImage ? (
                                        <a href={website.coverImage} target="_blank">View Image</a>
                                      ) : (null)}
                                    </div>
                                    <button
                                      className="save"
                                      type="submit"
                                      onClick={this.saveWebsite.bind(
                                        this,
                                        index,
                                        website_index
                                      )}
                                    >
                                      <i className="fa fa-check" />
                                    </button>

                                  </div>
                                );
                              }.bind(this)
                            )}
                          </div>
                        </div>
                      );
                    }.bind(this)
                  )
                : null}

              {this.state.ngos.length === 0 ? (
                <div className="orgs-not-found-container">
                  <h3>No Organisations were found!</h3>
                </div>
              ) : null}
            </div>
          ) : null}
          <div className="text-center">
            <ReactPaginate
              breakLabel={<a>...</a>}
              breakClassName={"break-me"}
              pageCount={this.state.pageCount}
              marginPagesDisplayed={1}
              pageRangeDisplayed={3}
              onPageChange={this.handlePageClick}
              containerClassName={"pagination"}
              subContainerClassName={"pages pagination"}
              activeClassName={"active"}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ManageSwayam/ManageSwayam.js